import script from "./MyAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyAccount.vue?vue&type=script&setup=true&lang=ts"

import "./MyAccount.vue?vue&type=style&index=0&id=6ab70336&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab70336"]])

export default __exports__